/* HELIOS Pro Pack bundle — auto-added with the ring (Leo 2026-06-19).
   ULTRA subscription = 1-free-month Recharge plan, then monthly; extras are $0 'included'. */
window.EXP5_EXTRAS = [
  { id: 44211551273075, quantity: 1, selling_plan: 3151200371 }, /* THRIVE ULTRA - 1 free month */
  { id: 45116375269491, quantity: 1 },                          /* Travel Charging Case (Pro Pack) */
  { id: 45116375203955, quantity: 1 },                          /* Cycling Wellness */
  { id: 45116375236723, quantity: 1 },                          /* THRIVE Coverage - 2 Year */
  { id: 45366798319731, quantity: 1 }                           /* FARINA + CLIQ Light Set — product 8365558300787 (unlisted) */
];

/* Named constants for the lights item — used by the cart-probe dedupe guard
   in helios-addtocart.liquid and (defensively) here. Keep in sync with the
   id above and with helios-cart-item.liquid's product-id check.
   LIGHTS REBUILD (staged, off-live): cart-wiring mechanics on this page
   reuse .agents/exp5/lights-bonus-work/ verbatim (dedupe guard, bundle-add,
   drawer "what's included" row) — not part of the visual proof pack. */
window.THRIVE_LIGHTS_VARIANT_ID = 45366798319731;
window.THRIVE_LIGHTS_PRODUCT_ID = 8365558300787;

/* =============================================================
   THRIVE HELIOS · Experimental 5 — interactivity
   - Finish + size pickers wired to Shopify variants
   - Scroll-driven fan (Founders Pack tiles)
   - Scroll-driven phone fan (App download)
   - Gallery snap-detect + thumb sync
   - Add-to-cart -> /cart/add.js
   ============================================================= */
(function() {
  'use strict';
  const roots = document.querySelectorAll('.exp5-root');
  if (!roots.length) return;
  roots.forEach(function(root) {

  // ---------- Variant data wired from Liquid via data-* ----------
  // root.dataset.variants is a JSON-encoded array of {id, finish, size, available, price}
  let variants = [];
  try { variants = JSON.parse(root.dataset.variants || '[]'); } catch(e) {}
  const productHandle = root.dataset.productHandle || '';
  const state = {
    finish: (root.dataset.defaultFinish || 'black').toLowerCase(),
    size: parseInt(root.dataset.defaultSize || '9', 10),
    sizingKit: true
  };

  function findVariant(finish, size) {
    return variants.find(v =>
      String(v.finish).toLowerCase() === String(finish).toLowerCase() &&
      parseInt(v.size, 10) === parseInt(size, 10)
    );
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateForVariant() {
    const v = findVariant(state.finish, state.size);
    const priceEl = root.querySelector('[data-exp5-price]');
    const stickyPrice = root.querySelector('[data-exp5-sticky-price]');
    if (v) {
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      // Update EVERY add-to-cart CTA — the buy box AND the mobile sticky cart both use
      // [data-exp5-cta], and the sticky cart sits OUTSIDE .exp5-root, so this must be
      // document-wide. Previously only the first CTA updated, so the sticky cart kept
      // adding the default (Black) variant on mobile. (Leo 2026-07-03)
      document.querySelectorAll('[data-exp5-cta]').forEach(function(cta){
        cta.dataset.variantId = v.id;
        cta.disabled = !v.available;
        var label = cta.querySelector('[data-exp5-cta-label]');
        if (label && !v.available) label.textContent = 'Sold out';
      });
      // Update ring image on cycling-stack + sticky cart
      root.querySelectorAll('[data-exp5-ring-img]').forEach(img => {
        img.dataset.finish = state.finish;
      });
      // Update fan ring tile photo
      // Finish image map (shared by the fan ring tile + the sticky bar thumbnail).
      var finishImg = {};
      try { finishImg = root.dataset.finishImg ? JSON.parse(root.dataset.finishImg) : {}; } catch(e) {}
      const ringTile = root.querySelector('[data-exp5-fan-ring]');
      if (ringTile && finishImg[state.finish]) ringTile.src = finishImg[state.finish];
      // Sync the desktop sticky buy-bar (lives OUTSIDE .exp5-root) — thumbnail, finish/size text, add-to-cart variant.
      if (finishImg[state.finish]) document.querySelectorAll('[data-hd-sticky-img]').forEach(function(img){ img.src = finishImg[state.finish]; });
      var __sf = { black: 'Titanium Black', silver: 'Titanium Silver', gold: 'Aster Gold' };
      document.querySelectorAll('[data-hd-sticky-finish]').forEach(function(el){ el.textContent = __sf[state.finish] || __sf.black; });
      document.querySelectorAll('[data-hd-sticky-size]').forEach(function(el){ el.textContent = state.sizingKit ? 'Sizing kit' : ('US ' + state.size); });
      document.querySelectorAll('[data-hd-addtocart]').forEach(function(c){ c.setAttribute('data-variant-id', v.id); });
    }
  }

  // ---------- Finish picker ----------
  root.querySelectorAll('[data-exp5-finish]').forEach(btn => {
    btn.addEventListener('click', function() {
      const f = btn.dataset.exp5Finish;
      state.finish = f;
      root.querySelectorAll('[data-exp5-finish]').forEach(b => {
        b.setAttribute('aria-pressed', b.dataset.exp5Finish === f ? 'true' : 'false');
      });
      // Update finish label
      const labels = { black: 'Titanium Black', silver: 'Titanium Silver', gold: 'Aster Gold' };
      const labelEl = root.querySelector('[data-exp5-finish-label]');
      if (labelEl) labelEl.textContent = labels[f] || labels.black;
      const numEl = root.querySelector('[data-exp5-finish-num]');
      if (numEl) numEl.textContent = String(['black','silver','gold'].indexOf(f) + 1).padStart(2, '0');
      updateForVariant();
    });
  });

  // ---------- Size picker ----------
  root.querySelectorAll('[data-exp5-size]').forEach(btn => {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      state.size = parseInt(btn.dataset.exp5Size, 10);
      state.sizingKit = false;
      root.querySelectorAll('[data-exp5-size]').forEach(b => {
        b.setAttribute('aria-pressed', parseInt(b.dataset.exp5Size, 10) === state.size ? 'true' : 'false');
      });
      const kitRadio = root.querySelector('[data-exp5-kit-indicator]');
      if (kitRadio) kitRadio.style.border = '1.5px solid #cccbcc';
      updateForVariant();
    });
  });

  // ---------- Sizing-kit toggle ----------
  const kitBtn = root.querySelector('[data-exp5-kit-toggle]');
  if (kitBtn) {
    kitBtn.addEventListener('click', function() {
      state.sizingKit = true;
      const kitRadio = root.querySelector('[data-exp5-kit-indicator]');
      if (kitRadio) kitRadio.style.border = '6px solid #205eee';
      root.querySelectorAll('[data-exp5-size]').forEach(b => b.setAttribute('aria-pressed', 'false'));
      updateForVariant();
    });
  }

  // ---------- Accordions ----------
  // Native <details>/<summary> handles expand/collapse. CSS rotates the + via [open] selector.
  // No JS handler needed.

  // ---------- Add to cart ----------
  root.querySelectorAll('[data-exp5-cta]').forEach(cta => {
    cta.addEventListener('click', async function() {
      const variantId = cta.dataset.variantId;
      if (!variantId) return;
      cta.disabled = true;
      const labelEl = cta.querySelector('[data-exp5-cta-label]');
      const original = labelEl ? labelEl.textContent : '';
      if (labelEl) labelEl.textContent = 'Adding...';
      try {
        const mainItem = { id: variantId, quantity: 1 };
        // Sizing-kit flow: no ring size committed yet (no size button pressed) — flag the line so the
        // cart, checkout and order-confirmation email don't read as if the buyer chose a specific size.
        if (!document.querySelector('[data-exp5-size][aria-pressed="true"]')) { mainItem.properties = { 'Size': 'To be confirmed with your free sizing kit' }; }
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [mainItem].concat(window.EXP5_EXTRAS || []) })
        });
        if (res.ok) {
          if (labelEl) labelEl.textContent = 'Added — go to cart';
          setTimeout(() => {
            try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch(e) {}
            try { if (window.upcartOpenCart) { window.upcartOpenCart(); return; } } catch(e) {}
            var __cd = document.querySelector('cart-drawer');
            if (__cd && typeof __cd.open === 'function') { __cd.open(); return; }
            window.location.href = '/cart';
          }, 600);
        } else {
          throw new Error('Add to cart failed');
        }
      } catch(e) {
        if (labelEl) labelEl.textContent = 'Try again';
        setTimeout(() => { if (labelEl) labelEl.textContent = original; }, 1500);
      } finally {
        cta.disabled = false;
      }
    });
  });

  // ---------- Gallery snap detect + thumb sync ----------
  const rail = root.querySelector('[data-exp5-gallery-rail]');
  if (rail) {
    const thumbs = root.querySelectorAll('[data-exp5-thumb]');
    const onScroll = () => {
      const idx = Math.round(rail.scrollLeft / rail.clientWidth);
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === idx ? 'true' : 'false'));
    };
    rail.addEventListener('scroll', onScroll, { passive: true });
    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => {
        rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' });
      });
    });
  }

  // ---------- Scroll-driven fan (Founders Pack tiles) ----------
  function setupScrollFan(el, opts) {
    if (!el) return;
    const tiles = Array.from(el.querySelectorAll('.exp5-fan-card'));
    if (!tiles.length) return;
    tiles.forEach(function(t){ t.style.willChange='transform'; t.style.backfaceVisibility='hidden'; });
    const cardW = parseInt(el.dataset.cardW || '84', 10);
    const overlap = parseInt(el.dataset.overlap || '64', 10);
    const totalW = cardW + (tiles.length - 1) * overlap;
    const stackedLeft = (totalW - cardW) / 2;

    const update = () => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const top = rect.top;
      const start = vh;
      const end = vh / 3;
      const t = Math.max(0, Math.min(1, (start - top) / (start - end)));
      const e = 1 - Math.pow(1 - t, 3);
      tiles.forEach((tile, i) => {
        const targetLeft = i * overlap;
        const tx = (stackedLeft - targetLeft) * (1 - e);
        const rot = parseFloat(tile.dataset.targetRot || '0') * e;
        tile.style.transform = `translateX(${tx}px) rotate(${rot}deg)`;
      });
    };
    update();
    let raf;
    const tick = () => { update(); raf = null; };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    window.addEventListener('resize', update);
  }
  setupScrollFan(root.querySelector('[data-exp5-fan]'));

  // ---------- Scroll-driven phone fan ----------
  function setupPhoneFan(el) {
    if (!el) return;
    const left = el.querySelector('[data-exp5-phone-left]');
    const right = el.querySelector('[data-exp5-phone-right]');
    if (!left || !right) return;
    left.style.willChange='transform'; right.style.willChange='transform';
    left.style.backfaceVisibility='hidden'; right.style.backfaceVisibility='hidden';
    const SIDE_X = 100, SIDE_Y = -20, SIDE_ROT = 0, SIDE_SCALE_END = 0.94, SIDE_SCALE_START = 0.88;

    const update = () => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const center = rect.top + rect.height / 2;
      const start = vh * 0.85;
      const end = vh * 0.40;
      const t = Math.max(0, Math.min(1, (start - center) / (start - end)));
      const e = 1 - Math.pow(1 - t, 4);
      const lerp = (a, b) => a + (b - a) * e;
      const lx = lerp(0, -SIDE_X), ly = lerp(0, SIDE_Y), lrot = lerp(0, -SIDE_ROT), lsc = lerp(SIDE_SCALE_START, SIDE_SCALE_END);
      const rx = lerp(0, SIDE_X), ry = lerp(0, SIDE_Y), rrot = lerp(0, SIDE_ROT), rsc = lerp(SIDE_SCALE_START, SIDE_SCALE_END);
      left.style.transform = `translate(${lx}px, ${ly}px) rotate(${lrot}deg) scale(${lsc})`;
      right.style.transform = `translate(${rx}px, ${ry}px) rotate(${rrot}deg) scale(${rsc})`;
    };
    update();
    let raf;
    const tick = () => { update(); raf = null; };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    window.addEventListener('resize', update);
  }
  setupPhoneFan(root.querySelector('[data-exp5-phone-stage]'));

  // ---------- Countdown timer (announcement bar) ----------
  const cd = root.querySelector('[data-exp5-countdown]');
  if (cd) {
    let s = 23 * 3600 + 59 * 60 + 58;
    const tick = () => {
      s = Math.max(0, s - 1);
      const h = String(Math.floor(s / 3600)).padStart(2, '0');
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      cd.textContent = `${h}:${m}:${ss}`;
    };
    setInterval(tick, 1000);
  }

  // ---------- Sticky promo (slides down once user scrolls) ----------
  const promo = root.querySelector('[data-exp5-sticky-promo]');
  if (promo) {
    let mode = window.__EXP5_PROMO_MODE || 'pinned';
    try { const q = new URLSearchParams(location.search).get('spmode'); if (q === 'reveal' || q === 'pinned') mode = q; } catch (e) {}
    let lastY = window.scrollY || 0;
    const onScroll = () => {
      const y = window.scrollY || 0;
      if (mode === 'reveal') {
        // Alternate: show while scrolling DOWN, slide back UP while scrolling up so the sticky
        // header (cart / currency / menu) beneath is reachable. Hidden near the very top.
        if (y <= 24) promo.dataset.visible = 'false';
        else if (y > lastY + 4) promo.dataset.visible = 'true';
        else if (y < lastY - 4) promo.dataset.visible = 'false';
      } else {
        promo.dataset.visible = y > 24 ? 'true' : 'false';   // current: appear once scrolled, stay
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Hide Marco card on slides other than slide 0 ----------
  const marco = root.querySelector('[data-exp5-marco-card]');
  if (marco && rail) {
    const onRailScroll = () => {
      const idx = Math.round(rail.scrollLeft / rail.clientWidth);
      marco.style.display = idx === 0 ? '' : 'none';
    };
    rail.addEventListener('scroll', onRailScroll, { passive: true });
    onRailScroll();
  }

  // ---------- Scroll-triggered "What to expect" cards ----------
  const expectSection = root.querySelector('[data-exp5-expect]');
  if (expectSection && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          expectSection.classList.add('exp5-in-view');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    io.observe(expectSection);
  } else if (expectSection) {
    // No IntersectionObserver — just reveal immediately
    expectSection.classList.add('exp5-in-view');
  }

  // ---------- Team modal (View the team) ----------
  const teamModal = root.querySelector('[data-exp5-team-modal]');
  if (teamModal) {
    const openBtns = root.querySelectorAll('[data-exp5-team-open]');
    const closeBtns = teamModal.querySelectorAll('[data-exp5-team-close]');
    const openModal = () => {
      teamModal.classList.add('is-open');
      teamModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const closeModal = () => {
      teamModal.classList.remove('is-open');
      teamModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    openBtns.forEach(b => b.addEventListener('click', openModal));
    closeBtns.forEach(b => b.addEventListener('click', closeModal));
    // Backdrop click (tap outside the card)
    teamModal.addEventListener('click', (e) => { if (e.target === teamModal) closeModal(); });
    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && teamModal.classList.contains('is-open')) closeModal();
    });
  }

  // ---------- Initial state ----------
    updateForVariant();
  });
})();

/* ──────────────────────────────────────────────────────────────
   DESKTOP SECTION — separate handler for .exp5-desktop-root
   ────────────────────────────────────────────────────────────── */
(function(){
  'use strict';
  const droot = document.querySelector('.exp5-desktop-root');
  if (!droot) return;

  let dvariants = [];
  try { dvariants = JSON.parse(droot.dataset.variants || '[]'); } catch(e) {}
  const dstate = {
    finish: (droot.dataset.defaultFinish || 'black').toLowerCase(),
    size: parseInt(droot.dataset.defaultSize || '9', 10)
  };

  function dfindVariant(f, s) {
    return dvariants.find(v =>
      String(v.finish).toLowerCase() === String(f).toLowerCase() &&
      parseInt(v.size, 10) === parseInt(s, 10)
    );
  }
  function dformatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function dupdateForVariant() {
    const v = dfindVariant(dstate.finish, dstate.size);
    if (!v) return;
    droot.querySelectorAll('[data-exp5d-price], [data-exp5d-sticky-price]').forEach(el => el.textContent = dformatMoney(v.price));
    droot.querySelectorAll('[data-exp5d-cta]').forEach(cta => {
      cta.dataset.variantId = v.id;
      cta.disabled = !v.available;
    });
  }

  // Finish picker
  droot.querySelectorAll('[data-exp5d-finish]').forEach(btn => {
    btn.addEventListener('click', function() {
      dstate.finish = btn.dataset.exp5dFinish;
      droot.querySelectorAll('[data-exp5d-finish]').forEach(b => b.setAttribute('aria-pressed', b.dataset.exp5dFinish === dstate.finish ? 'true' : 'false'));
      const labels = { black: 'Titanium Black', silver: 'Titanium Silver', gold: 'Aster Gold' };
      const labelEl = droot.querySelector('[data-exp5d-finish-label]');
      if (labelEl) labelEl.textContent = labels[dstate.finish] || labels.black;
      dupdateForVariant();
    });
  });

  // Size picker
  droot.querySelectorAll('[data-exp5d-size]').forEach(btn => {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      dstate.size = parseInt(btn.dataset.exp5dSize, 10);
      droot.querySelectorAll('[data-exp5d-size]').forEach(b => {
        const active = parseInt(b.dataset.exp5dSize, 10) === dstate.size;
        b.style.background = active ? '#205eee' : (b.disabled ? '#f7f8fb' : '#fff');
        b.style.color = active ? '#fff' : (b.disabled ? '#b3b2b2' : '#000');
        b.style.border = active ? '1.5px solid #205eee' : '1px solid #d9d9d9';
      });
      dupdateForVariant();
    });
  });

  // Add to cart
  droot.querySelectorAll('[data-exp5d-cta]').forEach(cta => {
    cta.addEventListener('click', async function() {
      const variantId = cta.dataset.variantId;
      if (!variantId) return;
      cta.disabled = true;
      const label = cta.querySelector('[data-exp5d-cta-label]');
      const orig = label ? label.textContent : '';
      if (label) label.textContent = 'Adding...';
      try {
        const mainItem = { id: variantId, quantity: 1 };
        // Sizing-kit flow: no ring size committed yet (no size button pressed) — flag the line so the
        // cart, checkout and order-confirmation email don't read as if the buyer chose a specific size.
        if (!document.querySelector('[data-exp5-size][aria-pressed="true"]')) { mainItem.properties = { 'Size': 'To be confirmed with your free sizing kit' }; }
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [mainItem].concat(window.EXP5_EXTRAS || []) })
        });
        if (res.ok) {
          if (label) label.textContent = 'Added — go to cart';
          setTimeout(() => {
            try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch(e) {}
            try { if (window.upcartOpenCart) { window.upcartOpenCart(); return; } } catch(e) {}
            var __cd = document.querySelector('cart-drawer');
            if (__cd && typeof __cd.open === 'function') { __cd.open(); return; }
            window.location.href = '/cart';
          }, 600);
        } else throw new Error('add failed');
      } catch(e) {
        if (label) label.textContent = 'Try again';
        setTimeout(() => { if (label) label.textContent = orig; }, 1500);
      } finally { cta.disabled = false; }
    });
  });

  // Sticky promo (drops in after 5% scroll). Bottom buy bar is permanent — no JS toggle.
  const dpromo = droot.querySelector('[data-exp5d-sticky-promo]');
  if (dpromo) {
    let dmode = window.__EXP5_PROMO_MODE || 'pinned';
    try { const q = new URLSearchParams(location.search).get('spmode'); if (q === 'reveal' || q === 'pinned') dmode = q; } catch (e) {}
    let dLastY = window.scrollY || 0;
    const onScroll = () => {
      const y = window.scrollY || 0;
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      const threshold = Math.max(120, docH * 0.05);
      if (dmode === 'reveal') {
        if (y <= threshold) dpromo.dataset.visible = 'false';
        else if (y > dLastY + 4) dpromo.dataset.visible = 'true';
        else if (y < dLastY - 4) dpromo.dataset.visible = 'false';
      } else {
        dpromo.dataset.visible = y > threshold ? 'true' : 'false';
      }
      dLastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Countdown
  const dcd = droot.querySelector('[data-exp5d-countdown]');
  if (dcd) {
    let s = 23 * 3600 + 59 * 60 + 58;
    setInterval(() => {
      s = Math.max(0, s - 1);
      const h = String(Math.floor(s / 3600)).padStart(2, '0');
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      dcd.textContent = `${h}:${m}:${ss}`;
    }, 1000);
  }

  dupdateForVariant();
})();
